/* eslint-disable sort-imports */

class FormAndContentItem {
  constructor(block) {
    this.block = block;

    this.selectors = {
      location: '.b-form-and-content__location',
      map: '.c-map',
    };

    this.classes = {};

    this.bootstrap();
  }

  bootstrap() {
    const links = [ ...this.block.querySelectorAll(this.selectors.location) ];
    const map = this.block.querySelector(this.selectors.map);

    if (!map) {
      return;
    }

    links.forEach(link => {
      link.addEventListener('click', () => {
        const { index } = link.dataset;

        map.dispatchEvent(
          new CustomEvent('focusMarker', {
            detail: { index },
          }),
        );
      });
    });
  }
}

export default class FormAndContent {
  constructor() {
    this.selector = '.b-form-and-content';
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    this.wrappers.forEach(wrapper => new FormAndContentItem(wrapper));
  }
}
